import React from 'react';
// MODULES
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
// ANTD
import Select from 'antd/lib/select';
import 'antd/lib/select/style/css';
//
// CONSTANTS AND DESTRUCTURING
// ================================================================
const Option = Select.Option;

// EXPORTED COMPONENT
// ================================================================
const SavedLineItemsInput = ({
  lineItems, currencySymbol, currentLineItemId, onSelectChange,
}) => {
  const optionChildren = lineItems.map(item => (
    <Option key={item._id} value={item._id}>
      <div>
        <p style={{ fontSize: 17, color: '#000' }}>
          <span style={{ color: '#2ecc71', marginRight: 4 }}>
            {CurrencyHelpers.centsToDollars(item.amount, { symbol: currencySymbol })}
          </span>{' '}
          {item.title || ''}:{' '}
          <span style={{ fontSize: 12, color: '#999', marginLeft: 4 }}> {item.description || ''}</span>
        </p>
      </div>
    </Option>
  ));

  const _handleChange = _id => {
    let lineItem = lineItems.find(item => item._id === _id);
    onSelectChange(lineItem);
  };

  return (
    <Select
      showSearch
      size="large"
      optionFilterProp="children"
      value={currentLineItemId}
      style={{ width: '100%' }}
      onChange={_id => _handleChange(_id)}
      filterOption={GeneralHelpers.selectSearchFilter}
    >
      {optionChildren}
    </Select>
  );
};

export default SavedLineItemsInput;



// WEBPACK FOOTER //
// ./src/components/inputs/SavedLineItemsInput/index.js